import React, { useEffect } from 'react';
import {
  Button,
  Dialog,
  HeadingText,
  BodyText,
  Link,
} from '@paypalcorp/pp-react';
import Illustration from '../illustrations/Illustration';
import PropTypes from 'prop-types';
import { trackEventWithData } from '../../utilsV3/analytics';

const BasicModal = ({
  buttonLabel,
  buttonOnClick,
  buttonState,
  children,
  className,
  closeOnBackgroundClick,
  fptiSpec = {},
  header,
  linkLabel,
  linkOnClick,
  iconType,
  id,
  isOpen,
  message1,
  message2,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen) {
      trackEventWithData(fptiSpec.impression, fptiSpec.data);
    }
  }, [isOpen, id]);

  return (
    <Dialog
      id={id}
      containerClassName={className}
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div>
          <Illustration
            type={iconType}
            id="modal-illustration"
            data-testid="modal-illustration"
          />
          <HeadingText size="lg" className="modal-header">
            {header}
          </HeadingText>
        </div>
      }
      closeOnBackgroundClick={closeOnBackgroundClick}
    >
      {children}

      {message1 && <BodyText className="modal-body-msg-1">{message1}</BodyText>}
      {message2 && <BodyText className="modal-body-msg-2">{message2}</BodyText>}

      {buttonLabel && (
        <Button
          type="submit"
          onClick={buttonOnClick}
          btnState={buttonState}
          className="modal-button"
        >
          {buttonLabel}
        </Button>
      )}

      {linkLabel && (
        <Link onClick={linkOnClick} className="modal-link">
          {linkLabel}
        </Link>
      )}
    </Dialog>
  );
};

BasicModal.propTypes = {
  buttonLabel: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonState: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  closeOnBackgroundClick: PropTypes.bool,
  fptiSpec: PropTypes.object,
  header: PropTypes.string,
  linkLabel: PropTypes.string,
  linkOnClick: PropTypes.func,
  iconType: PropTypes.string,
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  message1: PropTypes.string,
  message2: PropTypes.string,
  onClose: PropTypes.func,
};

export default BasicModal;
